import { take, select } from 'redux-saga/effects';

import { SAVE_CONFIGURATION } from './actions';
import handleThirdPartyLibs from './handleThirdPartyLibs';


function* loadScripts() {
  while (true) {
    yield take(SAVE_CONFIGURATION);

    const { 
      reader: {
        configuration: readingConfig
      }
    } = yield select(state => state);

    yield handleThirdPartyLibs(readingConfig);
  }
}

export default loadScripts;
